module.exports = __webpack_public_path__ + "static/img/4.dd233d72.jpg";